import script from "./ModalEditUserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditUserInfo.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditUserInfo.vue?vue&type=style&index=0&id=25a9536c&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a9536c"]])

export default __exports__